import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse, createParamString } from 'data_sources/constants';

export type UserRolesResponseItem = {
  roleId: string;
  roleName: string;
};

export type UserRolesResponse = {
  roles: UserRolesResponseItem[];
};

export default function useUserRoles(
  organizationId: string,
  userId: string,
  params = {},
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexid/admin-user/v1/organizations/${organizationId}/users/${userId}/roles`;
  return useQuery<UserRolesResponse, ServerErrorResponse>(
    ['user_roles', organizationId, userId],
    async ({ signal }): Promise<UserRolesResponse> => {
      try {
        const paramString = createParamString(params);
        const data: UserRolesResponse = await fetcher({
          method: 'get',
          url: `${url}?${paramString}`,
          options: { signal },
        });

        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      keepPreviousData: true,
      ...options,
    }
  );
}
